import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export const UploadImage = async (
    url: string,
    type: string,
    image: File,
    userId: string
) => {
    const token = cookies.get("authToken");
    try {
        const response = await axios.post(
            `${url}/UserDocument/Create`,
            {
                Type: type,
                Image: image,
                UserId: userId
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )

        return response.data;
    } catch (error) {
        console.error(error);

        throw error;
    }
}

export const GetUserDocuments = async (
    url: string,
    userId: string
) => {
    const token = cookies.get("authToken");

    try {
        const response = await axios.get(
            `${url}/UserDocument/GetByUserId/${userId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )

        return response.data;
    } catch (error) {
        console.error(error);

        throw error;
    }
}

export const UpdateUserDocumentApi = async (
    url: string,
    Id: string,
    Image: string
) => {
    const token = cookies.get("authToken"); // Replace with your token retrieval logic

    try {
        const response = await axios.put(
            `${url}/UserDocument/Update`, // Endpoint URL
            {
                Id: Id,
                Image: Image
            }, // Request body
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json", // Specify JSON content type
                },
            }
        );
        return response.data; // Return the response data
    } catch (error) {
        console.error("Failed to update user document:", error);
        throw error;
    }
};